var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoDragonPorteno(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.92 28.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.9,8.9h8.81v5.81a3.19,3.19,0,0,1-3.19,3.18H3.9V15.77H5.29V11H3.9ZM10.59,11H7.41v4.75H9.52a1.07,1.07,0,0,0,1.07-1.06Z",
    transform: "translate(-0.23 -4.3)",
    style: {
      fill: "#8b2c34",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.07,17.89H18.94a2.6,2.6,0,0,0-2.6-2.6h-.42v2.6H13.8v-9h7.05v2.81a3.27,3.27,0,0,1-1.44,2.73A4.33,4.33,0,0,1,21.07,17.89Zm-5.15-4.61H17.4A1.33,1.33,0,0,0,18.73,12V11H15.92Z",
    transform: "translate(-0.23 -4.3)",
    style: {
      fill: "#8b2c34",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.78,15.77h.29v2.12h-.29A2.5,2.5,0,0,1,28,17.18a2.77,2.77,0,0,1-1.87.71h-1.4a2.83,2.83,0,0,1-2.83-2.83V12.17h5.3v-.1A1.07,1.07,0,0,0,26.14,11H22.27V8.9h3.87a3.18,3.18,0,0,1,3.19,3.17v3.25A.46.46,0,0,0,29.78,15.77Zm-2.57-.71v-.77H24v.77a.71.71,0,0,0,.71.71H26.5A.71.71,0,0,0,27.21,15.06Z",
    transform: "translate(-0.23 -4.3)",
    style: {
      fill: "#8b2c34",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.67,8.9h7.41V11h-5.3v3.69a1.07,1.07,0,0,0,1.07,1.06H36V14.34H34.15V12.22h3.93v5.67H33.85a3.19,3.19,0,0,1-3.18-3.18Z",
    transform: "translate(-0.23 -4.3)",
    style: {
      fill: "#8b2c34",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7,11.37v6.52H41.76a2.48,2.48,0,0,1-2.47-2.47V8.9h4.94A2.48,2.48,0,0,1,46.7,11.37Zm-2.12,0a.35.35,0,0,0-.35-.35H41.41v4.4a.35.35,0,0,0,.35.35h2.82Z",
    transform: "translate(-0.23 -4.3)",
    style: {
      fill: "#8b2c34",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.48,17.27l-1.72,1.24a5.73,5.73,0,0,1-1.09-3.73V11H50.84a1.06,1.06,0,0,0-1.06,1.05v5.82H47.66V12.07A3.18,3.18,0,0,1,50.84,8.9h4v5.88a4.42,4.42,0,0,0,.44,2.15A2.48,2.48,0,0,0,55.48,17.27Z",
    transform: "translate(-0.23 -4.3)",
    style: {
      fill: "#8b2c34",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.48,23.29H8.91v2.94a3.47,3.47,0,0,1-3.45,3.46H4v2.6H1.86V25.42H.48Zm6.31,2.13H4v2.14H5.46a1.34,1.34,0,0,0,1.33-1.33Z",
    transform: "translate(-0.23 -4.3)",
    style: {
      fill: "#8b2c34",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.29,25.77v6.52H12.35a2.48,2.48,0,0,1-2.47-2.47V23.29h4.94A2.48,2.48,0,0,1,17.29,25.77Zm-2.12,0a.35.35,0,0,0-.35-.35H12v4.4a.35.35,0,0,0,.35.35h2.82Z",
    transform: "translate(-0.23 -4.3)",
    style: {
      fill: "#8b2c34",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.64,32.29H23.52a2.61,2.61,0,0,0-2.61-2.6h-.42v2.6H18.37v-9h7.05v2.82A3.27,3.27,0,0,1,24,28.84,4.33,4.33,0,0,1,25.64,32.29Zm-5.15-4.61H22a1.34,1.34,0,0,0,1.33-1.33v-.93H20.49Z",
    transform: "translate(-0.23 -4.3)",
    style: {
      fill: "#8b2c34",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.36,23.29H34v2.13H31.22v6.87H29.09V25.42H26.36Z",
    transform: "translate(-0.23 -4.3)",
    style: {
      fill: "#8b2c34",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.56,23.29H42v2.28a3.28,3.28,0,0,1-3.27,3.28h-2v.26a1.07,1.07,0,0,0,1.06,1.06H42v2.12H37.74a3.19,3.19,0,0,1-3.18-3.18Zm2.12,3.57h2a1.17,1.17,0,0,0,1.15-1.17v-.27H36.68Z",
    transform: "translate(-0.23 -4.3)",
    style: {
      fill: "#8b2c34",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.89,31.67l-1.72,1.24a5.73,5.73,0,0,1-1.09-3.73V25.42H46.25a1.06,1.06,0,0,0-1.06,1v5.82H43.07V26.47a3.19,3.19,0,0,1,3.18-3.18h4v5.89a4.42,4.42,0,0,0,.44,2.15A2.48,2.48,0,0,0,50.89,31.67Z",
    transform: "translate(-0.23 -4.3)",
    style: {
      fill: "#8b2c34",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9,25.77v6.52H54a2.48,2.48,0,0,1-2.47-2.47V23.29h4.94A2.48,2.48,0,0,1,58.9,25.77Zm-2.12,0a.35.35,0,0,0-.35-.35H53.61v4.4a.35.35,0,0,0,.35.35h2.82Z",
    transform: "translate(-0.23 -4.3)",
    style: {
      fill: "#8b2c34",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,4.69l.93,1.55-2.8,1.69-.63-1Z",
    transform: "translate(-0.23 -4.3)",
    style: {
      fill: "#8b2c34",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.77,20.88h6.38v1.29H43.77Z",
    transform: "translate(-0.23 -4.3)",
    style: {
      fill: "#8b2c34",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDragonPorteno);
export default __webpack_public_path__ + "static/media/logo-dragon-porteno.a4156bf5aa4604dd686f8bf2a24faa81.svg";
export { ForwardRef as ReactComponent };